import { render, staticRenderFns } from "./XZReport.vue?vue&type=template&id=6bc6b72a&scoped=true&lang=html&"
import script from "./XZReport.vue?vue&type=script&lang=js&"
export * from "./XZReport.vue?vue&type=script&lang=js&"
import style0 from "./XZReport.vue?vue&type=style&index=0&id=6bc6b72a&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc6b72a",
  null
  
)

export default component.exports